import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/EditFormModal";
import TipForm from "./TipForm";
const EditTips = () => {
  const CurdRProps = useSelector((state) => state.CurdR);
  const { Edit_Tips_Modal, initialValues, Loader } = CurdRProps;
  const [form] = Form.useForm();

  return (
    <div>
      <FormModal
        modalTitle="Edit Tip"
      
        submitButtonText="Update"
        cancelButtonText="Cancel"
        editApiRequest="EditRecord"
        apiLoader="StartSpinner"
        editApiMethod="PUT"
        editApiName="editTip"
        ModalName="Edit_Tips_Modal"
        confirmLoading={Loader}
        ModalType="Hide_Modal"
        visible={Edit_Tips_Modal ? Edit_Tips_Modal : false}
        initialValues={initialValues}
        width={550}
        form={form}
        recordName="tipsList"
      >
        <TipForm />
      </FormModal>
    </div>
  );
};

export default EditTips;
